import { requestStructuredOutput } from "@/lib/ai/structured-outputs";
import { PageInWP } from "../wp-page-manager/types";
import * as t from "io-ts";
import { jsonStringifyOrUndefined } from "@/util/json-stringify-or-undefined";
import { makeWordPressAjaxRequest } from "@/lib/wordpress/ajax";
import { pipe } from "fp-ts/lib/function";
import { fold } from "fp-ts/lib/Either";

export async function getImportantPagesForMenuWithAI(
  pages: PageInWP[],
  maxPages: number
) {
  const pagesWithIndex = pages.map(page => ({
    title: page.title,
    id: page.id
  }));

  const importantPageIdsFromAi = await requestStructuredOutput(
    `what are the most important pages for the header menu for our website in this list of pages? return them in the order they should appear in a header menu. return up to ${maxPages} pages

        ${jsonStringifyOrUndefined(pagesWithIndex)}

        `,
    t.type({
      pageIds: t.array(t.number)
    })
  );

  if (!importantPageIdsFromAi) {
    console.error("No important pages found");
    return [];
  }

  const importantPageIds = importantPageIdsFromAi.pageIds;

  return importantPageIds;
}

export async function syncToDefaultWPMenu(pages: PageInWP[]) {
  const importantPageIds = await getImportantPagesForMenuWithAI(pages, 5);

  return pipe(
    await makeWordPressAjaxRequest({
      action: "breakdance_singularity_sync_pages_to_default_wp_menu",
      decoder: t.type({ success: t.string }),
      dataToPost: {
        pageIds: jsonStringifyOrUndefined(importantPageIds)
      }
    }),
    fold(
      () => null,
      response => {
        console.log("Menu updated successfully:", response.success);
      }
    )
  );
}
